<template>
  <router-link class="sub-grafica"
    v-if="isSubGrafica"
    :to="to"
  >
    <slot />
  </router-link>
  <div v-else>
    <slot />
  </div>
</template>

<script>
export default {
  name: "Item",
  props: {
    isSubGrafica: {
      type: Boolean,
      default: false
    },
    to:{}
  }
};
</script>

<style lang="scss" scoped></style>
